import complaintManagementsList from './complaintManagementsList';
import complaintManagementsEdit from './complaintManagementsEdit';
// import complaintManagementsCreate from './complaintManagementsCreate';
import ComplaintManagementsShow from './complaintManagementsShow';

export default {
    list: complaintManagementsList,
    edit: complaintManagementsEdit,
    show: ComplaintManagementsShow,
    // create: complaintManagementsShow
}